<h1 mat-dialog-title></h1>
<div mat-dialog-content>
    <div class="flex flex-column align-center">
        <mat-icon color="warn">warning</mat-icon>
        <h1>Tem certeza ?</h1>
        <span> Não será possível reverter posteriormente!</span>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="remove(true)" color="primary">Sim, excluir</button>
    <button mat-raised-button (click)="remove(false)" color="warn">Cancelar</button>
</div>
